import {
  getGamesForSkill,
  normalizeSkillKey,
  type NeurogresGame,
  type NeurogresSkill,
} from "./skillGameMap";

export interface GamePlan {
  recommendedGames: NeurogresGame[];
  rationale: string[];
}

function normalizeList(skills: Array<NeurogresSkill | string> = []): NeurogresSkill[] {
  return Array.from(new Set(
    skills.map((skill) => normalizeSkillKey(skill)).filter(Boolean)
  )) as NeurogresSkill[];
}

function rationaleFor(game: NeurogresGame, skill: NeurogresSkill): string {
  return `${game} supports ${skill} in the current cycle.`;
}

export function buildGamePlan(
  targetSkills: Array<NeurogresSkill | string> = [],
  maxGames = 3
): GamePlan {
  const skills = normalizeList(targetSkills).slice(0, 5);
  const cappedMax = Math.max(1, Math.min(3, Number(maxGames) || 3));
  const recommendedGames: NeurogresGame[] = [];
  const rationale: string[] = [];

  skills.forEach((skill) => {
    getGamesForSkill(skill).forEach((game) => {
      if (recommendedGames.includes(game) || recommendedGames.length >= cappedMax) return;
      recommendedGames.push(game);
      rationale.push(rationaleFor(game, skill));
    });
  });

  return {
    recommendedGames,
    rationale,
  };
}
